import { render, staticRenderFns } from "./LoginHelpLink.component.vue?vue&type=template&id=08b63a67&"
import script from "./LoginHelpLink.component.vue?vue&type=script&lang=ts&"
export * from "./LoginHelpLink.component.vue?vue&type=script&lang=ts&"
import style0 from "./LoginHelpLink.component.vue?vue&type=style&index=0&id=08b63a67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports